import { render } from "./UserSwitchModal.vue?vue&type=template&id=7e8fdadd&scoped=true"
import script from "./UserSwitchModal.vue?vue&type=script&lang=js"
export * from "./UserSwitchModal.vue?vue&type=script&lang=js"

import "./UserSwitchModal.vue?vue&type=style&index=0&id=7e8fdadd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8fdadd"]])

export default __exports__